module.exports = __webpack_public_path__ + "img/168.c3c4162d.jpg";